module.exports = __webpack_public_path__ + "static/media/move-placeholder-square.c71a0ea0.svg";